import FontFaceObserver from 'fontfaceobserver';

export default async function waitForFonts() {
  const observer = new FontFaceObserver('Poppins');
  return observer.load();
}
